import { getAll } from "../utilities/querySelector";

getAll( '[href="#next-section"], [data-next-section]' ).forEach( link => {
    link.addEventListener( 'click', e => {
        e.preventDefault();
        e.currentTarget;
        const parentSection = e.currentTarget.closest( 'main > *' );
        nextSection( parentSection )?.scrollIntoView();
    } );
} );

function nextSection( el ) {
    let nextSection = el.nextElementSibling;
    while ( nextSection !== null && nextSection.tagName !== "SECTION" ) {
        nextSection = nextSection.nextElementSibling;
    }
    return nextSection;
}